<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="submitSearch"
                >
                    <div class="row">
                        <div class="col d-flex align-items-center w-100">
                            <input
                                type="search"
                                name="customer_search"
                                placeholder="Search by customer"
                                v-model="form.customer_search"
                                class="form-control"
                            >
                            <label
                                class="d-block w-auto mt-1 mx-2"
                                style="white-space: nowrap;"
                            >
                                <input
                                    type="checkbox"
                                    v-model="form.show_completed"
                                >
                                <span>Show Complete</span>
                            </label>
                            <button
                                class="btn btn-secondary"
                                type="submit"
                            >
                                Search
                            </button>
                        </div>
                        <div class="ml-auto col text-right">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="toggleNewTask"
                            >
                                + New Task
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <p v-if="loading">
                            Loading...
                        </p>
                        <p v-if="!loading && tasks.length === 0">
                            <span> No tasks found,</span>
                            <button
                                class="btn btn-link p-0"
                                type="button"
                                @click="toggleNewTask"
                            >
                                try adding a new one
                            </button>
                        </p>
                        <table
                            v-if="tasks.length > 0"
                            class="table"
                        >
                            <thead>
                                <tr>
                                    <th>Customer</th>
                                    <th>Site</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="task in tasks"
                                    :key="task.id"
                                    @click="openTask(task)"
                                    class="task-row"
                                >
                                    <td>{{ task.customer.company_name }}</td>
                                    <td>{{ task.site ? task.site.name : 'N/A' }}</td>
                                    <td>{{ task.type_label }}</td>
                                    <td>{{ task.status }}</td>
                                    <td>{{ task.updated_at| datetime }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <modal
            ref="newTaskModal"
            title="New Task"
            class-name="modal--overflow"
        >
            <new-task-form @saved="toggleNewTask" />
        </modal>
        <modal
            ref="editTaskModal"
            :title="editTask ? `${editTask.type_label} for ${editTask.customer.company_name}` : ''"
            @close="closeTask()"
        >
            <edit-task
                @change="submitSearch"
                @close="editTask = null"
                v-if="editTask"
                :task-id="editTask.id"
            />
        </modal>
    </div>
</template>

<script>
import { search } from "../../../services/TaskService";
import NewTaskForm from "./NewTaskForm.vue";
import Modal from "../../modals/ModalComponent.vue";
import EditTask from "../task-manager/EditTask.vue";

export default {
    components: {
        NewTaskForm,
        Modal,
        EditTask,
    },
    data() {
        return {
            loading: false,
            form: {
                customer_search: "",
                show_completed: false,
            },
            tasks: [],
            showNewTask: false,
            editTask: null,
        };
    },
    watch: {
        showNewTask() {
            if (this.showNewTask) {
                this.$refs.newTaskModal.open();
                return;
            }
            this.$refs.newTaskModal.close();
        },
        editTask() {
            if (this.editTask === null) {
                this.$refs.editTaskModal.close();
                return;
            }
            this.$refs.editTaskModal.open();
        },
    },
    mounted() {
        this.submitSearch();
    },
    methods: {
        toggleNewTask() {
            this.showNewTask = !this.showNewTask;
            this.submitSearch();
        },

        submitSearch() {
            this.loading = true;
            search(this.form).then(({ data }) => {
                this.tasks = data;
                this.loading = false;
            });
        },
        openTask(task) {
            this.editTask = task;
        },
        closeTask() {
            this.editTask = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.task-row {
    &:hover {
        cursor: pointer;
        background-color: #d8d9e9;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/task-manager/Index.vue